import { Button, Card, Watermark , Modal, message ,Spin} from 'antd';
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { CloseCircleOutlined } from '@ant-design/icons';


const backend_url = process.env.REACT_APP_BACKEND_URL;




const TicketCard = ({ ticket }) => {
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [ticketData, setTicketData] = useState(ticket); // Track ticket data in state
    const [loading, setLoading] = useState(false); // Loading state for spinner
    const [isTicketCancelled, setIsTicketCancelled] = useState(false); // Flag for checking cancellation status

    // Function to show confirmation modal
    const showConfirmModal = () => {
        setIsModalVisible(true);
    };

    // Function to handle cancel ticket API call
    const cancelTicket = async (ticketNumber) => {
        setLoading(true); // Start loading spinner
        try {
            const response = await axios.patch(`${backend_url}/api/cancel-booking/${ticketNumber}`);
            console.log('Booking canceled:', response.data);

            // Update ticket status to "cancelled"
            setTicketData((prevState) => ({
                ...prevState,
                status: 'cancelled',
            }));

            setIsModalVisible(false);
            setIsTicketCancelled(true); // Mark the ticket as cancelled to trigger page reload
        } catch (error) {
            console.error('Error canceling booking:', error);
        } finally {
            setLoading(false); // Stop loading spinner
        }
    };

    // Function to handle modal OK click
    const handleOk = () => {
        cancelTicket(ticketData.ticketNumber);
    };

    // Function to handle modal Cancel click
    const handleCancel = () => {
        setIsModalVisible(false);
    };

    // Trigger modal and set ticket data to be canceled
    const verifyCancel = (ticketNumber) => {
        showConfirmModal();
    };

    // Effect to reload the page only once after the ticket is cancelled
    if (isTicketCancelled) {
        // window.location.reload();
        console.log('cancled')
    }

    return (
        <>

            <Card className="relative w-full max-w-md my-5 rounded-lg shadow-md overflow-hidden">
                <Watermark
                    zIndex={1}
                    content={ticketData.status === 'cancelled' ? 'CANCELLED' : 'n-Bus Ticket'}
                    font={{
                        color: ticketData.status === 'cancelled' ? 'rgba(255, 0, 0, 0.5)' : 'rgba(0, 0, 0, 0.1)',
                        fontSize: ticketData.status === 'cancelled' ? 32 : 16,
                    }}
                >
                    <div className="bg-red-500 p-4 text-white flex justify-between items-center rounded-3xl">
                        <div className="text-lg font-bold">{ticketData.busName}</div>
                        {ticketData.status !== 'cancelled' && (
                            <p onClick={() => verifyCancel(ticketData.ticketNumber)} className="my-auto cursor-pointer">
                                Cancel Ticket
                                <CloseCircleOutlined className="ml-2" />
                            </p>
                        )}
                    </div>

                    <div className="p-4 relative">
                        <div className="flex justify-between">
                            <div>
                                <h2 className="text-sm font-semibold text-gray-500">From:</h2>
                                <p className="text-lg font-bold text-gray-800">{ticketData.fromCity}</p>
                            </div>
                            <div>
                                <h2 className="text-sm font-semibold text-gray-500">To:</h2>
                                <p className="text-lg font-bold text-gray-800">{ticketData.toCity}</p>
                            </div>
                        </div>
                        <div className="flex justify-between mt-4">
                            <div>
                                <h2 className="text-sm font-semibold text-gray-500">Departure:</h2>
                                <p className="text-lg font-bold text-gray-800">{ticketData.travelDate}</p>
                            </div>
                            <div>
                                <h2 className="text-sm font-semibold text-gray-500">Arrival:</h2>
                                <p className="text-lg font-bold text-gray-800">{ticketData.travelDate}</p>
                            </div>
                        </div>
                        <div className="flex justify-between mt-4">
                            <div>
                                <h2 className="text-sm font-semibold text-gray-500">Bus No:</h2>
                                <p className="text-lg font-bold text-gray-800">{ticketData.busNumber}</p>
                            </div>
                            <div>
                                <h2 className="text-sm font-semibold text-gray-500">Number of Seats:</h2>
                                <p className="text-lg font-bold text-gray-800">{ticketData.seatNumber}</p>
                            </div>
                        </div>

                        <div className="border-t border-dashed mt-4 pt-4 flex justify-between">
                            <span className="text-sm font-bold text-gray-500">Ticket No:</span>
                            <span className="text-lg font-bold text-gray-800">{ticketData.ticketNumber}</span>
                        </div>
                    </div>
                </Watermark>
            </Card>

            {/* Ant Design Spin (loading spinner) */}
            {/* {loading && <Spin tip="Cancelling ticket..." className='absolute' size="large" >
                </Spin>} */}

            <Modal
                title="Confirm Ticket Cancellation"
                visible={isModalVisible}
                onOk={handleOk}
                onCancel={handleCancel}
                okText="Yes, Cancel"
                cancelText="No"
                confirmLoading={loading} // Disable buttons while loading
            >
                <p>Are you sure you want to cancel this ticket?</p>
            </Modal>
        </>
    );
};







function Ticket() {
    const [ticketdata, setTicketdata] = useState([]);
    const [loading, setLoading] = useState(true); // Loading state to show spinner
    const user = useSelector((data) => data.userdetailreducer);

    // Fetch the user's ticket data
    const getuser = async () => {
        try {
            const response = await axios.post(`${backend_url}/api/get-booking-ticket`, {
                ticketNumbers: user.ticketNumbers,
            });
            if (response.data && response.data.bookings) {
                setTicketdata(response.data.bookings);
            }
        } catch (error) {
            console.error('Error fetching booking tickets:', error);
        } finally {
            setLoading(false); // Stop loading once data is fetched
        }
    };

    useEffect(() => {
        if (user?.ticketNumbers) {
            getuser();
        }
    }, [user]);

    return (
        <>
            {loading ? (
                <div className="min-h-screen flex justify-center items-center">
                    <Spin size="large" tip="Loading your tickets..." />
                </div>
            ) : (
                <>
                    {ticketdata.length !== 0 ? (
                        <div className="flex flex-wrap justify-around w-full bg-gray-200">
                            {ticketdata.map((ticket) => (
                                <TicketCard key={ticket._id} ticket={ticket} />
                            ))}
                        </div>
                    ) : (
                        <div className="min-h-screen flex flex-col justify-center items-center bg-gray-100">
                            <div className="bg-white p-8 rounded-lg shadow-lg max-w-md w-full text-center">
                                <div className="mb-4">
                                    <svg
                                        className="w-24 h-24 mx-auto text-red-500"
                                        fill="none"
                                        stroke="currentColor"
                                        viewBox="0 0 24 24"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth="2"
                                            d="M9 14l6-6m0 0l6 6m-6-6v12"
                                        ></path>
                                    </svg>
                                </div>
                                <h2 className="text-2xl font-bold text-gray-800 mb-2">
                                    No Bookings Found
                                </h2>
                                <p className="text-gray-600 mb-6">
                                    You haven't made any bookings yet. Start exploring and book your next trip now!
                                </p>
                                <Link to="/" className="bg-red-500 hover:bg-red-600 text-white font-bold py-2 px-4 rounded-full transition duration-300">
                                    Book Now
                                </Link>
                            </div>
                        </div>
                    )}
                </>
            )}
        </>
    );
}

export default Ticket;
